import { Tabs, Divider } from 'antd';
import { UnorderedListOutlined, CalendarOutlined ,InsertRowAboveOutlined} from '@ant-design/icons';
import DailyReport from './DailyReport';
import MonthReport from './MonthReport';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import OccupationReport from './OccupationReport';
import SpendPerJobReport from './SpendPerJobReport';
import constants from '../../constants/constants';
import OccupationMatrix from './OccupationMatrix';
import ApplicationLog from './ApplicationLog';
import QualityReport from './QualityReport';
import InterviewsHires from './InterviewsHires';
import Cookies from 'js-cookie';
import AppScore from './AppScore';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
import LocationReport from './LocationReport';

const { TabPane } = Tabs;

const ApplicationReport = () => {

  //Variable declaration
  const [dateValues,setDateValues]=useState(null);
  const [tabValue,seTabValue]=useState(
    Number(sessionStorage.getItem('applicationReportTab') || 2)
  );
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
    return () => {
      const keepTab = sessionStorage.getItem('keepApplicationReportTab');
      if (keepTab === 'true') {
        sessionStorage.removeItem('keepApplicationReportTab');
      } else {
        sessionStorage.removeItem('applicationReportTab');
        sessionStorage.removeItem('appScoreFilters');
      }
    };
  }, []);
  //Functions
  //Functon to set changed date value
  const changeDate=(selectedDate)=>{
    setDateValues(selectedDate);
  }

	//On load function call
	// useEffect(()=>{
	// },[tabValue]);
  const onTabChange = (key) => {
    seTabValue(key);
    sessionStorage.setItem('applicationReportTab', key);
  };
	return (
		<div>
      <div className='uppercase font-bold text-xl'>Application Report</div>
			<Divider className='my-3'/>
      <Tabs activeKey={String(tabValue)} onChange={onTabChange}>
      <TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportShortTab2}</span> }
        key={2}
      >
        <MonthReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportShortTab1}</span> }
        key={1}
      >
        <DailyReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><InsertRowAboveOutlined className='text-xl' />{constants.AppReportTab7}</span> }
        key={7}
      >
        <QualityReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      <TabPane
          tab={<span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab9}</span> }
        key={9}
      >
        <AppScore changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab3}</span> }
        key={3}
      >
        <OccupationReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      <TabPane
        tab={<span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab10}</span>}
        key={10}
      >
        <LocationReport changeDate={changeDate} dateSelectedValue={dateValues} />
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab4}</span> }
        key={4}
      >
        <OccupationMatrix />
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><InsertRowAboveOutlined className='text-xl' />{constants.AppReportTab8}</span> }
        key={8}
      >
        <InterviewsHires changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab5}</span> }
        key={5}
      >
        <SpendPerJobReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
      {(Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true) ||!( Cookies.get(constants.COOKIE_CANDIDATE_TAB) === "true" || Cookies.get(constants.COOKIE_CANDIDATE_TAB) === true)?
      <TabPane
        tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab6}</span> }
        key={6}
      >
        <ApplicationLog changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>:null}
			</Tabs>
		</div>
	);
};

export default ApplicationReport;